import { render } from "./App.vue?vue&type=template&id=1eb8faf2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1eb8faf2&lang=scss"
script.render = render

export default script